const Dashboard = [
  {
    path: '/dashboard/overview',
    name: 'dashboard-overview',
    component: () => import(/* webpackChunkName: "overview" */'./pages/dashboard.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/dashboard/sales-by-history',
    name: 'dashboard-sales-by-history',
    component: () => import(/* webpackChunkName: "sales-by-history" */'./pages/SalesByHistory.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/dashboard/sales-by-location',
    name: 'dashboard-sales-by-location',
    component: () => import(/* webpackChunkName: "sales-by-location" */'./pages/SalesByLocation.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/dashboard/top-states',
    name: 'dashboard-top-states',
    component: () => import(/* webpackChunkName: "top-states" */'./pages/TopStates.vue'),
    meta: {
      requiresAuth: true,
    },
  },
];

export default Dashboard;
